import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-header-top-dropdown-template]' })
export class GridHeadeTopDropdownTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
